/**
 * Share of full volume the host's playlist music plays at during a livestream,
 * so the host's voice stays on top: volume 100 on the host's slider is 30%.
 * The OBS dock applies it to the host's own track; web viewers of a direct
 * OBS stream apply it when their player plays the host's music.
 */
export const LIVE_MUSIC_VOLUME_SCALE = 0.3;

/**
 * Seconds a web viewer's HLS picture runs behind the host. Song changes, play
 * and pause reach the viewer this late so they line up with the video.
 */
export const HLS_AUDIENCE_DELAY_SEC = 15;
